import { memo, useEffect, useState } from "react";
import Question from "./components/Question";
import { Container } from "@inlet/react-pixi";
import GameDialog from "../../baseComponents/GameContainer/components/GameDialog";

import gameOk from "../../assets/games/TransferenciaPrestamo/transferencia_gana.png";
import gameWrong from "../../assets/games/TransferenciaPrestamo/transferencia_pierde.png";
import ProgressBar from "../../baseComponents/ProgressBar";

const questions = [
  {
    question: "¿Qué necesito para completar una transferencia correctamente?",
    options: [
      "Solo el nombre del destinatario",
      "Número de cuenta o CLABE, nombre del destinatario y monto",
      "Fecha de nacimiento del destinatario",
    ],
    answer: "Número de cuenta o CLABE, nombre del destinatario y monto",
  },
  {
    question: "¿Dónde puedo encontrar mi número de referencia para pagar?",
    options: [
      "En el correo de confirmación",
      "No se muestra",
      "En la última página de mi Estado de Cuenta",
    ],
    answer: "En la última página de mi Estado de Cuenta",
  },
  {
    question:
      "Si tengo una duda sobre la liquidación de mi préstamo, sé que debo hablar a...",
    options: [
      "Los contactos oficiales de Profuturo (Teléfono, Chats, Redes Sociales, etc.)",
      "Al asesor que me vendió el préstamo",
      "A mi mejor amig@",
    ],
    answer:
      "Los contactos oficiales de Profuturo (Teléfono, Chats, Redes Sociales, etc.)",
  },
];

const Index = ({ visible, close, reset, pension }) => {
  const TIME_LIMIT = 30;

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [hasFailed, setHasFailed] = useState(false);
  const [successGame, setSuccessGame] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    let isMounted = true;
    let timeoutId;
    const updateTime = () => {
      if (!isMounted) return;
      if (currentTime < TIME_LIMIT && visible) {
        timeoutId = setTimeout(() => {
          if (isMounted) setCurrentTime(currentTime + 1);
        }, 1000);
      } else if (currentTime >= TIME_LIMIT && visible) {
        if (isMounted) setHasFailed(true);
      } else if (!visible) {
        if (isMounted) setCurrentTime(0);
      }
    };
    updateTime();
    return () => {
      isMounted = false;
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [currentTime, visible]);

  // updateTime ahora está dentro de useEffect

  const onHandleAnswer = (isCorrect) => {
    if (!isCorrect) {
      return setHasFailed(true);
    }
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setSuccessGame(true);
    }
  };

  if (successGame) {
    return (
      <GameDialog
        image={gameOk}
        button="Continuar"
        close={() => {
          setCurrentTime(0);
          setHasFailed(false);
          setSuccessGame(false);
          close();
        }}
        scale={1}
        alpha={1}
      />
    );
  }

  if (hasFailed) {
    return (
      <GameDialog
        image={gameWrong}
        button="Reintentar"
        close={() => {
          setCurrentTime(0);
          setCurrentQuestion(0);
          setHasFailed(false);
          reset();
        }}
        scale={1}
        alpha={1}
      />
    );
  }

  console.log("==>", window.innerHeight);

  return (
    <Container>
      <ProgressBar
        value={currentTime}
        limit={TIME_LIMIT}
        x={window.innerWidth / 2 - 200}
        y={window.innerHeight > 800 ? 0 : -window.innerHeight * 0.15}
      />
      <Question
        question={questions[currentQuestion].question}
        options={questions[currentQuestion].options}
        rightAnswer={questions[currentQuestion].answer}
        onAnswer={onHandleAnswer}
      />
    </Container>
  );
};

export default Index;
